
let lastElement: HTMLElement
const animationEnd = (event: AnimationEvent) => (event.animationName === 'pong' && event.target instanceof HTMLElement) && event.target.remove()
const pingStart = (e: TouchEvent) => {
    const target = e.target as HTMLElement;
    if (!target.dataset.touch || target.dataset.touch === 'false') return;
    const { x, y, width, height } = target.getBoundingClientRect();
    const size = (width + height) / 2
    lastElement = document.createElement("i");
    lastElement.className = "ping";
    lastElement.style.width = `${size}px`;
    lastElement.style.height = `${size}px`;
    lastElement.style.left = `${e.touches[0].clientX - x - (size / 2)}px`;
    lastElement.style.top = `${e.touches[0].clientY - y - (size / 2)}px`;
    lastElement.addEventListener('animationend', animationEnd)

    target.appendChild(lastElement);
}
const pingEnd = (e: TouchEvent) => {
    const target = e.target as HTMLElement;
    if (!target.dataset.touch || target.dataset.touch === 'false' || !lastElement) return;

    lastElement.className = "ping pong";
}
export const onTouchStart = (e: TouchEvent) => {
    pingStart(e)

}
export const onTouchEnd = (e: TouchEvent) => {
    pingEnd(e)
}
export const onTouchCancel = (e: TouchEvent) => {
    pingEnd(e)
}